<button type="button" class="close fa-solid fa-xmark" [attr.aria-label]="'cart.button.close'| translate" (click)="bsModalRef.hide()">
</button>

<div *ngIf="!submitted">

    <div class="dsm-modal-header" translate="cart.reviews.how.do.you.rate"></div>

    <form class="product-review-edit" #userForm="ngForm" (ngSubmit)="onFormSubmit(userForm)">
        <div class="rating" [ngClass]="{'modified': rating > 0 }">
            <input type="radio" id="star1" (change)="onChange(1)" name="rating" class="sr-only" [value]="1" [(ngModel)]="rating" [checked]="rating == 1">
            <label aria-label="1 stars" for="star1" class="rating fa"></label>
            <input type="radio" id="star2" (change)="onChange(2)" name="rating" class="sr-only" [value]="2" [(ngModel)]="rating" [checked]="rating == 2">
            <label aria-label="2 stars" for="star2" class="rating fa"></label>
            <input type="radio" id="star3" (change)="onChange(3)" name="rating" class="sr-only" [value]="3" [(ngModel)]="rating" [checked]="rating == 3">
            <label aria-label="3 stars" for="star3" class="rating fa"></label>
            <input type="radio" id="star4" (change)="onChange(4)" name="rating" class="sr-only" [value]="4" [(ngModel)]="rating" [checked]="rating == 4">
            <label aria-label="4 stars" for="star4" class="rating fa"></label>
            <input type="radio" id="star5" (change)="onChange(5)" name="rating" class="sr-only" [value]="5" [(ngModel)]="rating" [checked]="rating == 5">
            <label aria-label="5 stars" for="star5" class="rating fa"></label>
        </div>
        <p>{{ratingTranslation}}</p>

        <button class="dsm btn btn-primary" [disabled]="submitDisabled" type="button" type="submit" translate="cart.submit.rating"></button>
    </form>
</div>

<div *ngIf="submitted" class="text-center review-confirmation">
    <p class="dsm-modal-header" translate="cart.reviews.thanks.for.your.feedback"></p>
    <button type="button" class="sr-button" [attr.aria-label]="'cart.button.close'| translate" (click)="bsModalRef.hide()">
        <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
    </button>
    <p translate="cart.reviews.your.feedback.explanation"></p>
</div>
